module.exports = __webpack_public_path__ + "img/icon_2_28.e4768b3c.png";